import formTypes from "./formTypes";

export function updateNotify( notify ){
  return { type : formTypes.UPDATE_NOTIFY,  payload : { notify_no : notify } }
}

export function updateClaimId( claim_id ){
  return { type : formTypes.UPDATE_CLAIMID,  payload : { claim_id : claim_id } }
}


export function getNotify(){
  return { type : formTypes.GET_NOTIFY }
}

export function clearNotify(){
  return { type : formTypes.CLEAR_NOTIFY }
}

export function updateLicense( payload ){
  return { type : formTypes.UPDATE_LICENSE,  payload : payload }
}

export function updateContactInfo( payload ){
  return { type : formTypes.UPDATE_CONTACT,  payload : payload }
}
export function updateContactInfoTemporary( payload ){
  return { type : formTypes.UPDATE_CONTACT_TEMPORARY,  payload : payload }
}

export function updateClaimType( payload ){
  return { type : formTypes.UPDATE_CLAIM_TYPE,  payload : payload }
}

export function updateRequestDocuments( payload ){
  return { type : formTypes.UPDATE_REQUEST_DOCUMENTS,  payload : payload }
}

export function getClaimInfoDocType1(){
  return { type : formTypes.GET_DOC_TYPE_1 }
}

export function updateDocsType1( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_1,  payload : payload }
}
export function updateDocsType2( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_2,  payload : payload }
}
export function updateDocsType3( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_3,  payload : payload }
}
export function updateDocsType4( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_4,  payload : payload }
}
export function updateDocsType5( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_5,  payload : payload }
}
export function updateDocsType6( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_6,  payload : payload }
}
export function updateDocsType7( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_7,  payload : payload }
}
export function updateDocsType8( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_8,  payload : payload }
}
export function updateDocsType9( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_9,  payload : payload }
}
export function updateDocsType10( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_10,  payload : payload }
}
export function updateDocsType11( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_11,  payload : payload }
}
export function updateDocsType12( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_12,  payload : payload }
}
export function updateDocsType13( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_13,  payload : payload }
}
export function updateDocsType14( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_14,  payload : payload }
}
export function updateDocsType15( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_15,  payload : payload }
}
export function updateDocsType16( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_16,  payload : payload }
}
export function updateDocsType17( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_17,  payload : payload }
}
export function updateDocsType18( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_18,  payload : payload }
}
export function updateDocsType19( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_19,  payload : payload }
}
export function updateDocsType20( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_20,  payload : payload }
}
export function updateDocsType21( payload ){
  return { type : formTypes.UPDATE_DOC_TYPE_21,  payload : payload }
}


export function deleteDocType1( index ){
  return { type : formTypes.DELETE_DOC_TYPE_1,  payload : { index : index } }
}
export function deleteDocType2( index ){
  return { type : formTypes.DELETE_DOC_TYPE_2,  payload : { index : index } }
}
export function deleteDocType3( index ){
  return { type : formTypes.DELETE_DOC_TYPE_3,  payload : { index : index } }
}
export function deleteDocType4( index ){
  return { type : formTypes.DELETE_DOC_TYPE_4,  payload : { index : index } }
}
export function deleteDocType5( index ){
  return { type : formTypes.DELETE_DOC_TYPE_5,  payload : { index : index } }
}
export function deleteDocType6( index ){
  return { type : formTypes.DELETE_DOC_TYPE_6,  payload : { index : index } }
}
export function deleteDocType7( index ){
  return { type : formTypes.DELETE_DOC_TYPE_7,  payload : { index : index } }
}
export function deleteDocType8( index ){
  return { type : formTypes.DELETE_DOC_TYPE_8,  payload : { index : index } }
}
export function deleteDocType9( index ){
  return { type : formTypes.DELETE_DOC_TYPE_9,  payload : { index : index } }
}
export function deleteDocType10( index ){
  return { type : formTypes.DELETE_DOC_TYPE_10,  payload : { index : index } }
}
export function deleteDocType11( index ){
  return { type : formTypes.DELETE_DOC_TYPE_11,  payload : { index : index } }
}
export function deleteDocType12( index ){
  return { type : formTypes.DELETE_DOC_TYPE_12,  payload : { index : index } }
}

export function deleteDocType13( index ){
  return { type : formTypes.DELETE_DOC_TYPE_13,  payload : { index : index } }
}

export function deleteDocType14( index ){
  return { type : formTypes.DELETE_DOC_TYPE_14,  payload : { index : index } }
}
export function deleteDocType15( index ){
  return { type : formTypes.DELETE_DOC_TYPE_15,  payload : { index : index } }
}
export function deleteDocType16( index ){
  return { type : formTypes.DELETE_DOC_TYPE_16,  payload : { index : index } }
}
export function deleteDocType17( index ){
  return { type : formTypes.DELETE_DOC_TYPE_17,  payload : { index : index } }
}
export function deleteDocType18( index ){
  return { type : formTypes.DELETE_DOC_TYPE_18,  payload : { index : index } }
}
export function deleteDocType19( index ){
  return { type : formTypes.DELETE_DOC_TYPE_19,  payload : { index : index } }
}
export function deleteDocType20( index ){
  return { type : formTypes.DELETE_DOC_TYPE_20,  payload : { index : index } }
}
export function deleteDocType21( index ){
  return { type : formTypes.DELETE_DOC_TYPE_21,  payload : { index : index } }
}


export function deleteDocType1All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_1_ALL,  payload : {  } }
}
export function deleteDocType2All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_2_ALL,  payload : {  } }
}
export function deleteDocType3All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_3_ALL,  payload : {  } }
}
export function deleteDocType4All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_4_ALL,  payload : {  } }
}
export function deleteDocType5All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_5_ALL,  payload : {  } }
}
export function deleteDocType6All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_6_ALL,  payload : {  } }
}
export function deleteDocType7All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_7_ALL,  payload : {  } }
}
export function deleteDocType8All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_8_ALL,  payload : {  } }
}
export function deleteDocType9All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_9_ALL,  payload : {  } }
}
export function deleteDocType10All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_10_ALL,  payload : {  } }
}
export function deleteDocType11All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_11_ALL,  payload : {  } }
}
export function deleteDocType12All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_12_ALL,  payload : {  } }
}
export function deleteDocType13All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_13_ALL,  payload : {  } }
}
export function deleteDocType14All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_14_ALL,  payload : {  } }
}
export function deleteDocType15All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_15_ALL,  payload : {  } }
}
export function deleteDocType16All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_16_ALL,  payload : {  } }
}
export function deleteDocType17All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_17_ALL,  payload : {  } }
}
export function deleteDocType18All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_18_ALL,  payload : {  } }
}
export function deleteDocType19All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_19_ALL,  payload : {  } }
}
export function deleteDocType20All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_20_ALL,  payload : {  } }
}
export function deleteDocType21All(  ){
  return { type : formTypes.DELETE_DOC_TYPE_21_ALL,  payload : {  } }
}
export function deleteDocTypeAll(  ){
  return { type : formTypes.DELETE_DOC_TYPE_ALL,  payload : {  } }
}